<mat-toolbar>Edit Question</mat-toolbar>
<div class="Dialog-body">
  <form>
    
    <mat-form-field style="width: 400px;padding-top: 1.25em;">
      <input matInput placeholder="Title">
    </mat-form-field>

      <mat-form-field class="DBSS">
        <mat-select placeholder="Question Type">
          <mat-option value="option-truefalse">True/False</mat-option>
          <mat-option value="option-multichoice">Multiple Choice</mat-option>
          <mat-option value="option-multiselect">Multiple Selection</mat-option>
        </mat-select>
      </mat-form-field>
    
      <mat-form-field class="DBSS">
        <mat-select placeholder="Slide">
          <mat-option value="option-url">Url</mat-option>
          <mat-option value="option-elves">Elves</mat-option>
          <mat-option value="option-image">Image</mat-option>
        </mat-select>
      </mat-form-field>
    
      <div class="buttonbelow">
        <button mat-button>Submit</button>
        <button mat-button (click)="DialogClose()">Cancel</button>    
      </div>
  </form>

</div>
